import model from '../../models-v2/crm/mail-templates';
import routeName from '../route-name';

export default [
  {
    path: '/admin/mailing/templates',
    name: routeName.mailTemplates.index,
    components: {
      default: () => import('../../pages/data-grid.vue'),
      topRightSection: () => import('../../views/pages/mailing/components/MailingTemplateTopRightSection.vue'),
      popup: () => import('../../views/pages/mailing/components/Popup.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Mailing', url: '' },
        { title: 'Szablony', url: '/admin/mailing/templates' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/admin/mailing/templates/add',
    name: routeName.mailTemplates.store,
    component: () => import('../../views/pages/mailing/components/MailingTemplateForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Mailing', url: '' },
        { title: 'Szablony', url: '/admin/mailing/templates' },
        { title: 'Dodawanie', url: '' },
      ],
    },
  },
  {
    path: '/admin/mailing/templates/edit/:id',
    name: routeName.mailTemplates.edit,
    component: () => import('../../views/pages/mailing/components/MailingTemplateForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Mailing', url: '' },
        { title: 'Szablony', url: '/admin/mailing/templates' },
        { title: 'Edycja', url: '' },
      ],
    },
  },
];